export default __webpack_public_path__ + "assets/apple-touch-icon-152x152-82389e2.png";